export default __webpack_public_path__ + "static/media/omint.e57762a4.jpg";